import BankModel from "./BankModel";
import LegalEntityBranchModel from "./LegalEntityBranchModel";

export default class LegalEntityModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.date = data.date ?? new Date(1970, 0, 1);
			this.name = data.name ?? '';
			this.description = data.description;
			this.taxNo = data.taxNo ?? '';
			this.kppNo = data.kppNo;
			
			this.legalAddress = data.legalAddress ?? '';
			this.actualAddress = data.actualAddress;
			this.bankAccountNo = data.bankAccountNo ?? '';
			this.email = data.email;
			this.siteUrl = data.siteUrl;			
			this.isExecutiveEntity = data.isExecutiveEntity ?? false;

			if (data.branches?.length) {
				this.branches = data.branches.map((_: any) => new LegalEntityBranchModel(_));
			}

			if (data.bank?.id) {
				this.bank = new BankModel(data.bank);
			}
		}
	}

	id = 0;
	date = new Date(1970, 0, 1);
	name = '';
	description: string | null = null;
	taxNo = '';
	kppNo: string | null = null;
	legalAddress = '';
	actualAddress: string | null = null;
	bankAccountNo = '';
	email: string | null = null;
	siteUrl: string | null = null;
	bank: BankModel | null = null;	
	isExecutiveEntity = false;
	branches: Array<LegalEntityBranchModel> | null = null;
}